import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Import all images
import recommend from '../assets/2461546.svg';
import medal from '../assets/vaadin_medal.svg';
import traveler from '../assets/Traveler.svg';
import bike from '../assets/Mountain Biking.svg';
import holiday from '../assets/Holiday.svg';
import backgroundImage from '../assets/a79c2ee3c64c55e52a27ef36260ec6df.jpeg';

import './Dashboard.css';

const EditProfile = ({ user, setUser, setIsEditing }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(user.profilePic);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);

    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (selectedFile) {
      setUser((prevState) => ({
        ...prevState,
        profilePic: preview,
      }));

      setIsEditing(false);
    }
  };

  return (
    <div className="edit-profile-container">
      <h3>Edit Profile Picture</h3>
      <form onSubmit={handleSubmit}>
        <input type="file" onChange={handleFileChange} />
        {preview && (
          <img
            src={preview}
            alt="Preview"
            style={{ width: '150px', borderRadius: '50%', marginTop: '10px' }}
          />
        )}
        <button type="submit">Save</button>
        <button type="button" onClick={() => setIsEditing(false)}>
          Cancel
        </button>
      </form>
    </div>
  );
};

// Main Dashboard Component
const Dashboard = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState(null);
  const [user, setUser] = useState({
    name: 'John Doe',
    profilePic: '/src/assets/Ellipse 38.svg',
  });

  const handleRedirect = () => {
    window.location.href = 'https://www.youtube.com'; 
  };

  const mockData = {
    countriesExplored: 2,
    tripsCompleted: 12,
    milesCovered: 12,
    wishlist: [
      { id: 1, name: 'Kyoto: Private tour Kansai Region', location: 'Japan' },
      { id: 2, name: 'Paris: City of Lights Tour', location: 'France' },
      { id: 3, name: 'New York: Big Apple Experience', location: 'USA' },
    ],
    totalRewardPoints: 223456,
    upcomingBookings: [
      { id: 1, name: 'Magical Malaysia Singapore tour', startDate: '12/03/24', endDate: '12/04/24' },
      { id: 2, name: 'Magical Malaysia Singapore tour', startDate: '12/03/24', endDate: '12/04/24' },
      { id: 3, name: 'Magical Malaysia Singapore tour', startDate: '12/03/24', endDate: '12/04/24' },
    ],
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/api/dashboard'); // Replace with your backend API endpoint
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const result = await response.json();
        setData(result);
      } catch (error) {
        console.error('Fetch error:', error);
        setData(mockData); // Use mock data if fetch fails
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div>
      <div style={{ fontWeight: '500', fontSize: '200%' }}>Dashboard</div>

      {/* Stats */}
      <div className="dashboard-details">
        <div className="dashboard-details-card">
          <img style={{ height: '70px', marginTop: '5px', marginRight: '10px' }} src={traveler} alt="Traveler Icon" />
          <div>
            <div>
              <div className='dashboard-data'>{data.countriesExplored.toString().padStart(3, '0')}</div>
              <div className="dashboard-label">Countries</div>
              <div className="dashboard-label">Explored</div>
            </div>
          </div>
        </div>
        <div className="dashboard-details-card">
          <img style={{ height: '70px', marginTop: '5px', marginRight: '10px' }} src={bike} alt="Biking Icon" />
          <div>
            <div>
              <div className='dashboard-data'>{data.tripsCompleted.toString().padStart(3, '0')}</div>
              <div className="dashboard-label">Trips</div>
              <div className="dashboard-label">Completed</div>
            </div>
          </div>
        </div>
        <div className="dashboard-details-card">
          <img style={{ height: '70px', marginTop: '5px', marginRight: '10px' }} src={holiday} alt="Holiday Icon" />
          <div>
            <div>
              <div className='dashboard-data'>{data.milesCovered.toString().padStart(3, '0')}</div>
              <div className="dashboard-label">Miles</div>
              <div className="dashboard-label">Covered</div>
            </div>
          </div>
        </div>
      </div>

      <div className='parent-dash' style={{ display: 'flex', width: '100%' }}>
        {/* Recommendation Section */}
        <div className="recommended">
          <div className="recommended-content">
            <div className="recommended-text">
              <p className="explore-text" style={{ color: '#FFFFFF', fontFamily: 'Roboto' }}>Top</p>
              <p className="explore-text" style={{ color: '#FFFFFF', fontFamily: 'Roboto' }}>Recommendations</p>
            </div>
            <button className="explore-button">Explore</button>
          </div>
        </div>

        {/* Wishlist and Reward Points */}
        <div className='right-dash' style={{ display: 'flex', flexDirection: 'column' }}>
          <div className="wishlist">
            <div className="wishlist-content">
              {/* {data.wishlist.map(item => (
                <div
                  // key={item.id}
                  // className="wishlist-content-details"
                  // style={{
                  //   backgroundImage: `url(${'../assets/a79c2ee3c64c55e52a27ef36260ec6df.jpeg'})`,
                  //   backgroundSize: 'cover',
                  //   backgroundPosition: 'center',
                  //   padding: '50px',
                  //   marginBottom: '10px'
                  }}
                >
                  <div>{item.name}</div>
                  <div style={{ marginLeft: 'auto' }}>{item.location}</div>
                </div>
              ))} */}
            </div>

            {/* Moved button inside wishlist */}
            <div style={{ display: 'flex', justifyContent: 'left', marginTop: '220px' }}>
              <button
                style={{
                  padding: '10px 20px',
                  borderRadius: '25px',
                  backgroundColor: '#541c9c',
                  color: '#fff',
                  border: 'none',
                  marginLeft: '20px'
                }}
              >
                View Wishlist
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Upcoming Bookings */}
      <div className='upcoming-parent'>
        <h3>Upcoming Bookings</h3>
        <div style={{ padding: '15px' }}>
          <div className="upcoming">
            {data.upcomingBookings.map(booking => (
              <div key={booking.id} className="upcoming-content"
                style={{
                  backgroundImage: `url(${backgroundImage})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  padding: '50px',
                  marginBottom: '10px'
                }}>
                <div className='recom-card'style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
                  <div>
                    <h4>{booking.name}</h4>
                    <div>Start date: {booking.startDate} End date: {booking.endDate}</div>
                  </div>
                  <button onClick={handleRedirect} style={{ height: '50px', width: '200px', padding: 'none' }}>View Details</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
